import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'chargingStateTranslate',
})
export class ChargingStateTranslatePipe implements PipeTransform {

	private readonly labels: Record<string, string> = {
		Standby: $localize`:@@ChargingStateStandby:Standby`,
		VehicleDetected: $localize`:@@ChargingStateVehicleDetected:Vehicle Detected`,
		Charging: $localize`:@@ChargingStateCharging:Charging`,
		ChargingWithVentilation: $localize`:@@ChargingStateChargingWithVentilation:Charging with Ventilation`,
		NoPower: $localize`:@@ChargingStateNoPower:No Power`,
		Error: $localize`:@@ChargingStateError:Error`,
		Offline: $localize`:@@ChargingStateOffline:Offline`
	};

	transform(state?: string): string {
		if (!state) {
			return '';
		}

		return this.labels[state] ?? state;
	}

}
